export default {
    name: '嘉宾图库',
    url: '/activity/activity-guest-img', // rest接口表名
    query: '', // rest接口query参数
    // 列表渲染列
    columns: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {title: '嘉宾级别', dataIndex: 'level'},
            {title: '级别描述', dataIndex: 'describe'},
        ]
    },
    // 列表查询表单
    queryForm: [
        {
            key: 'level',
            label: '',
            component: 'a-input',
            props: {
                placeholder: '输入嘉宾级别查询',
            },
        },
    ],
    // 新增/编辑查询表单
    items: [
        {
            key: 'level',
            label: '嘉宾级别',
            component: 'a-input',
            props: {
                placeholder: '请输入嘉宾级别',
            },
            rules: [{ required: true, message: '请输入嘉宾级别', trigger: 'blur' }]
        },
        {
            key: 'describe',
            label: '级别描述',
            component: 'a-input',
            props: {
                placeholder: '请输入级别描述',
            },
            rules: [{ required: true, message: '请输入级别描述', trigger: 'blur' }]
        },
        {
            key: 'requirement',
            label: '安保、接待要求',
            component: 'rich-editor',
            props: {
                placeholder: '该级别嘉宾的安保、接待要求'
            },
        }
    ],
    // 详情接口expand字段
    expand: '',
    init: {}, // 新增实体初始化字段
    // 详情渲染字段
    renderItems: ctx => {
        // eslint-disable-next-line no-unused-vars
        const h = ctx.$createElement
        return [
            {
                label: '嘉宾级别',
                key: 'level',
            },
            {
                label: '级别描述',
                key: 'describe',
            },
            {
                label: '安保、接待要求',
                key: 'requirement',
                rich: true
            },
        ]
    }
}
